var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedicalServices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4765_874",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4765_874)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.83073 21.0807C3.30365 21.0807 2.85243 20.8931 2.47708 20.5177C2.10174 20.1424 1.91406 19.6911 1.91406 19.1641V7.66406C1.91406 7.13698 2.10174 6.68576 2.47708 6.31042C2.85243 5.93507 3.30365 5.7474 3.83073 5.7474H7.66406V3.83073C7.66406 3.30365 7.85174 2.85243 8.22708 2.47708C8.60243 2.10174 9.05365 1.91406 9.58073 1.91406H13.4141C13.9411 1.91406 14.3924 2.10174 14.7677 2.47708C15.1431 2.85243 15.3307 3.30365 15.3307 3.83073V5.7474H19.1641C19.6911 5.7474 20.1424 5.93507 20.5177 6.31042C20.8931 6.68576 21.0807 7.13698 21.0807 7.66406V19.1641C21.0807 19.6911 20.8931 20.1424 20.5177 20.5177C20.1424 20.8931 19.6911 21.0807 19.1641 21.0807H3.83073ZM9.58073 5.7474H13.4141V3.83073H9.58073V5.7474ZM10.5391 14.3724V17.2474H12.4557V14.3724H15.3307V12.4557H12.4557V9.58073H10.5391V12.4557H7.66406V14.3724H10.5391Z",
    fill: "#695BD6"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalServices);
export default __webpack_public_path__ + "static/media/medical_services.cd13df806d884677d0506bd0b9ca0803.svg";
export { ForwardRef as ReactComponent };